(() => {
  const init = (root = document) => {
    const openers = root.querySelectorAll('[data-cm-showroom-open]');
    if (!openers.length) return;

    const getModalFromOpener = (opener) => {
      const id = opener.getAttribute('aria-controls');
      return id ? document.getElementById(id) : null;
    };

    const openModal = (modal) => {
      if (!modal) return;
      if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
      }
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      const panel = modal.querySelector('.cm-showroom-modal__panel');
      if (panel) panel.focus();
      document.documentElement.classList.add('cm-modal-lock');
    };

    const closeModal = (modal) => {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('cm-modal-lock');
    };

    openers.forEach((opener) => {
      if (opener.dataset.cmBound === '1') return;
      opener.dataset.cmBound = '1';

      const modal = getModalFromOpener(opener);
      if (!modal) return;

      opener.addEventListener('click', () => openModal(modal));

      modal.addEventListener('click', (e) => {
        if (e.target.closest('[data-cm-showroom-close]')) closeModal(modal);
      });

      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        if (!modal.classList.contains('is-open')) return;
        closeModal(modal);
        opener.focus();
      });
    });
  };

  // scroll lock
  if (!document.getElementById('cm-modal-lock-style')) {
    const style = document.createElement('style');
    style.id = 'cm-modal-lock-style';
    style.textContent = `.cm-modal-lock{overflow:hidden;}`;
    document.head.appendChild(style);
  }

  init();

  // Hvis temaet re-render sections (Shopify events)
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
